import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Input, Button, Modal, Skeleton, Empty, Avatar, Tooltip, Tag, Icon, Table, Menu, Dropdown } from 'antd';

import PermissionsFormModal from '~/containers/Permissions/Modals/PermissionsFormModal';
import PermissionsMatrixView from './PermissionsMatrixView';
import * as permissionsActions from '~/containers/Permissions/actions';

import {
    UsersHeader, UserAvatarGroup, PermissionCard, PermissionCardHeader, PermissionCardTitle,
    PermissionCardActions, ActionButton, ViewToggle, OrgChartContainer, OrgTreeWrapper, OrgTree,
    OrgRootCard, OrgConnector, OrgBranchContainer, OrgBranch, OrgGroupCard, OrgGroupTitle,
    OrgGroupCount, OrgUsersGrid, OrgUserCard, OrgUserInfo, OrgUserName,
} from './styles';


var PermissionsContent = function() {
    var dispatch = useDispatch();
    var list = useSelector(function(state) { return state.permissions.list; });
    var customPermissionsUsers = useSelector(function(state) { return state.permissions.customPermissionsUsers || []; });
    var isLoadingState = useState(true);
    var isLoading = isLoadingState[0];
    var setIsLoading = isLoadingState[1];
    var searchState = useState('');
    var search = searchState[0];
    var setSearch = searchState[1];
    var viewModeState = useState('list');
    var viewMode = viewModeState[0];
    var setViewMode = viewModeState[1];

    useEffect(function() {
        dispatch(permissionsActions.loadPermissionsGroups()).finally(function() {
            setIsLoading(false);
        });
    }, [dispatch]);

    var handleOpenModal = function(data) {
        dispatch(permissionsActions.openModal(data));
    };

    var handleDelete = function(id) {
        Modal.confirm({
            title: 'Excluir grupo de permissão',
            content: 'Tem certeza que deseja excluir este grupo? Esta ação não pode ser desfeita.',
            okText: 'Excluir',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: function() {
                dispatch(permissionsActions.remove(id));
            },
        });
    };

    var getInitials = function(name) {
        if (!name) return '?';
        var parts = name.split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    var getAvatarColor = function(name) {
        var colors = ['#1890ff', '#52c41a', '#722ed1', '#fa8c16', '#eb2f96', '#13c2c2', '#2f54eb'];
        var hash = 0;
        for (var i = 0; i < (name || '').length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    var filteredList = list.filter(function(item) {
        if (!search) return true;
        return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });

    var filteredCustomUsers = customPermissionsUsers.filter(function(user) {
        if (!search) return true;
        return user.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });

    // Sort: Sócio (ID 1) always first, then by user count
    var byGroupOrder = function(a, b) {
        if (a.id === 1) return -1;
        if (b.id === 1) return 1;
        var aUsers = a.users ? a.users.length : 0;
        var bUsers = b.users ? b.users.length : 0;
        return bUsers - aUsers;
    };
    var sortedList = filteredList.slice().sort(byGroupOrder);
    // A matriz mostra todos os grupos como colunas — a busca lá filtra as
    // permissões (linhas), não os grupos.
    var allSortedGroups = list.slice().sort(byGroupOrder);

    // Calculate total users
    var totalUsers = sortedList.reduce(function(sum, group) {
        return sum + (group.users ? group.users.length : 0);
    }, 0) + filteredCustomUsers.length;

    var renderListView = function() {
        return (
            <div>
                {sortedList.map(function(group) {
                    var permissionCount = group.permissions ? group.permissions.length : 0;
                    var users = group.users || [];
                    var displayUsers = users.slice(0, 5);
                    var extraCount = users.length - 5;
                    var isSocioGroup = group.id === 1;

                    return (
                        <PermissionCard key={group.id} style={isSocioGroup ? { borderColor: '#b7eb8f', background: '#fcfff6' } : {}}>
                            <PermissionCardHeader>
                                <PermissionCardTitle>
                                    {isSocioGroup ? (
                                        <Icon type="safety-certificate" style={{ color: '#52c41a' }} />
                                    ) : (
                                        <Icon type="folder" style={{ color: '#722ed1' }} />
                                    )}
                                    {group.name}
                                    {isSocioGroup ? (
                                        <Tag color="green" style={{ marginLeft: 4, fontSize: 11, lineHeight: '18px', height: 20 }}>
                                            <Icon type="lock" style={{ marginRight: 4, fontSize: 10 }} />
                                            Acesso total
                                        </Tag>
                                    ) : (
                                        <span style={{ color: '#8c8c8c', fontWeight: 400, fontSize: 13 }}>
                                            ({permissionCount} {permissionCount === 1 ? 'permissão' : 'permissões'})
                                        </span>
                                    )}
                                    {users.length > 0 && (
                                        <UserAvatarGroup>
                                            {displayUsers.map(function(u) {
                                                return (
                                                    <Tooltip key={u.id} title={u.name}>
                                                        <Avatar size="small" style={{ backgroundColor: isSocioGroup ? '#52c41a' : '#722ed1', fontSize: 10 }}>
                                                            {getInitials(u.name)}
                                                        </Avatar>
                                                    </Tooltip>
                                                );
                                            })}
                                            {extraCount > 0 && (
                                                <Tooltip title={users.slice(5).map(function(u) { return u.name; }).join(', ')}>
                                                    <Avatar size="small" style={{ backgroundColor: '#8c8c8c', fontSize: 10 }}>
                                                        +{extraCount}
                                                    </Avatar>
                                                </Tooltip>
                                            )}
                                        </UserAvatarGroup>
                                    )}
                                </PermissionCardTitle>
                                <PermissionCardActions>
                                    {isSocioGroup ? (
                                        <ActionButton onClick={function() { handleOpenModal(group); }}>
                                            <Icon type="eye" /> Visualizar
                                        </ActionButton>
                                    ) : (
                                        <React.Fragment>
                                            <ActionButton onClick={function() { handleOpenModal(group); }}>
                                                <Icon type="edit" /> Editar
                                            </ActionButton>
                                            {users.length > 0 ? (
                                                <Tooltip title="Não é possível excluir grupo com usuários vinculados">
                                                    <ActionButton style={{ opacity: 0.4, cursor: 'not-allowed' }}>
                                                        <Icon type="delete" /> Excluir
                                                    </ActionButton>
                                                </Tooltip>
                                            ) : (
                                                <ActionButton className="danger" onClick={function() { handleDelete(group.id); }}>
                                                    <Icon type="delete" /> Excluir
                                                </ActionButton>
                                            )}
                                        </React.Fragment>
                                    )}
                                </PermissionCardActions>
                            </PermissionCardHeader>
                        </PermissionCard>
                    );
                })}

                {filteredCustomUsers.length > 0 && (
                    <div style={{ marginTop: 24 }}>
                        <div style={{
                            fontSize: 13,
                            fontWeight: 500,
                            color: '#8c8c8c',
                            marginBottom: 12,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        }}>
                            <Icon type="user" />
                            Usuários com permissões personalizadas
                        </div>
                        <PermissionCard>
                            <PermissionCardHeader>
                                <PermissionCardTitle>
                                    <Icon type="setting" style={{ color: '#fa8c16' }} />
                                    Permissões Individuais
                                    <span style={{ color: '#8c8c8c', fontWeight: 400, fontSize: 13 }}>
                                        ({filteredCustomUsers.length} {filteredCustomUsers.length === 1 ? 'usuário' : 'usuários'})
                                    </span>
                                    <UserAvatarGroup>
                                        {filteredCustomUsers.slice(0, 8).map(function(u) {
                                            return (
                                                <Tooltip key={u.id} title={u.name + ' - ' + u.email}>
                                                    <Avatar size="small" style={{ backgroundColor: '#fa8c16', fontSize: 10 }}>
                                                        {getInitials(u.name)}
                                                    </Avatar>
                                                </Tooltip>
                                            );
                                        })}
                                        {filteredCustomUsers.length > 8 && (
                                            <Tooltip title={filteredCustomUsers.slice(8).map(function(u) { return u.name; }).join(', ')}>
                                                <Avatar size="small" style={{ backgroundColor: '#8c8c8c', fontSize: 10 }}>
                                                    +{filteredCustomUsers.length - 8}
                                                </Avatar>
                                            </Tooltip>
                                        )}
                                    </UserAvatarGroup>
                                </PermissionCardTitle>
                                <div style={{ fontSize: 12, color: '#8c8c8c' }}>
                                    Estes usuários possuem permissões configuradas individualmente
                                </div>
                            </PermissionCardHeader>
                        </PermissionCard>
                    </div>
                )}
            </div>
        );
    };

    var renderTableView = function() {
        var tableData = sortedList.map(function(group) {
            return {
                id: group.id,
                name: group.name,
                permissionCount: group.permissions ? group.permissions.length : 0,
                users: group.users || [],
                isCustom: false,
                group: group
            };
        });

        if (filteredCustomUsers.length > 0) {
            tableData.push({
                id: 'custom',
                name: 'Permissões Individuais',
                permissionCount: '-',
                users: filteredCustomUsers,
                isCustom: true,
                group: null
            });
        }

        return (
            <div className="table-clabs">
                <Table
                    rowKey="id"
                    dataSource={tableData}
                    pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '50'] }}
                    size="middle"
                >
                    <Table.Column
                        title="Grupo"
                        key="name"
                        render={function(text, record) {
                            var isSocioRow = record.id === 1;
                            return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <Icon
                                        type={record.isCustom ? 'setting' : isSocioRow ? 'safety-certificate' : 'folder'}
                                        style={{ color: record.isCustom ? '#fa8c16' : isSocioRow ? '#52c41a' : '#722ed1' }}
                                    />
                                    <span style={{ fontWeight: 500 }}>{record.name}</span>
                                    {isSocioRow && (
                                        <Tag color="green" style={{ fontSize: 11, lineHeight: '18px', height: 20 }}>
                                            <Icon type="lock" style={{ marginRight: 4, fontSize: 10 }} />
                                            Acesso total
                                        </Tag>
                                    )}
                                </div>
                            );
                        }}
                    />
                    <Table.Column
                        title="Permissões"
                        key="permissions"
                        render={function(text, record) {
                            if (record.isCustom) {
                                return <Tag color="orange">Individuais</Tag>;
                            }
                            if (record.id === 1) {
                                return <Tag color="green">Todas</Tag>;
                            }
                            return <Tag color="purple">{record.permissionCount}</Tag>;
                        }}
                    />
                    <Table.Column
                        title="Usuários"
                        key="users"
                        render={function(text, record) {
                            var users = record.users;
                            if (users.length === 0) {
                                return <span style={{ color: '#8c8c8c' }}>Nenhum</span>;
                            }
                            return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <UserAvatarGroup style={{ marginLeft: 0 }}>
                                        {users.slice(0, 3).map(function(u) {
                                            return (
                                                <Tooltip key={u.id} title={u.name}>
                                                    <Avatar size="small" style={{ backgroundColor: record.isCustom ? '#fa8c16' : '#722ed1', fontSize: 10 }}>
                                                        {getInitials(u.name)}
                                                    </Avatar>
                                                </Tooltip>
                                            );
                                        })}
                                        {users.length > 3 && (
                                            <Avatar size="small" style={{ backgroundColor: '#8c8c8c', fontSize: 10 }}>
                                                +{users.length - 3}
                                            </Avatar>
                                        )}
                                    </UserAvatarGroup>
                                    <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                                        {users.length} {users.length === 1 ? 'usuário' : 'usuários'}
                                    </span>
                                </div>
                            );
                        }}
                    />
                    <Table.Column
                        title=""
                        key="actions"
                        width={120}
                        render={function(text, record) {
                            if (record.isCustom) return null;

                            if (record.id === 1) {
                                return (
                                    <div style={{ display: 'flex', gap: 8 }}>
                                        <Tooltip title="Visualizar">
                                            <ActionButton onClick={function() { handleOpenModal(record.group); }}>
                                                <Icon type="eye" />
                                            </ActionButton>
                                        </Tooltip>
                                    </div>
                                );
                            }

                            var hasUsers = record.users.length > 0;
                            return (
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Tooltip title="Editar">
                                        <ActionButton onClick={function() { handleOpenModal(record.group); }}>
                                            <Icon type="edit" />
                                        </ActionButton>
                                    </Tooltip>
                                    {hasUsers ? (
                                        <Tooltip title="Não é possível excluir grupo com usuários">
                                            <ActionButton style={{ opacity: 0.4, cursor: 'not-allowed' }}>
                                                <Icon type="delete" />
                                            </ActionButton>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title="Excluir">
                                            <ActionButton className="danger" onClick={function() { handleDelete(record.id); }}>
                                                <Icon type="delete" />
                                            </ActionButton>
                                        </Tooltip>
                                    )}
                                </div>
                            );
                        }}
                    />
                </Table>
            </div>
        );
    };

    var renderOrgView = function() {
        return (
            <OrgChartContainer>
                <OrgTreeWrapper>
                <OrgTree>
                    <OrgRootCard>
                        <div className="title">
                            <Icon type="safety" style={{ marginRight: 8 }} />
                            Permissões
                        </div>
                        <div className="subtitle">{sortedList.length} grupos • {totalUsers} usuários</div>
                    </OrgRootCard>
                    <OrgConnector />
                    <OrgBranchContainer>
                        {sortedList.map(function(group) {
                            var users = group.users || [];
                            var permissionCount = group.permissions ? group.permissions.length : 0;

                            return (
                                <OrgBranch key={group.id}>
                                    <OrgGroupCard onClick={function() { handleOpenModal(group); }} style={group.id === 1 ? { borderColor: '#b7eb8f', background: '#fcfff6' } : {}}>
                                        <Icon type={group.id === 1 ? 'safety-certificate' : 'folder'} style={group.id === 1 ? { color: '#52c41a' } : {}} />
                                        <OrgGroupTitle>{group.name}</OrgGroupTitle>
                                        <OrgGroupCount>{group.id === 1 ? 'Acesso total' : permissionCount + ' permissões'}</OrgGroupCount>
                                    </OrgGroupCard>
                                    <OrgUsersGrid>
                                        {users.slice(0, 6).map(function(u) {
                                            return (
                                                <Tooltip
                                                    key={u.id}
                                                    title={
                                                        <div>
                                                            <div style={{ fontWeight: 500 }}>{u.name}</div>
                                                            <div style={{ fontSize: 11, opacity: 0.8 }}>{u.email}</div>
                                                        </div>
                                                    }
                                                    placement="bottom"
                                                >
                                                    <OrgUserCard>
                                                        <Avatar size={24} style={{ backgroundColor: getAvatarColor(u.name), flexShrink: 0, fontSize: 10 }}>
                                                            {getInitials(u.name)}
                                                        </Avatar>
                                                        <OrgUserInfo>
                                                            <OrgUserName>{u.name}</OrgUserName>
                                                        </OrgUserInfo>
                                                    </OrgUserCard>
                                                </Tooltip>
                                            );
                                        })}
                                        {users.length > 6 && (
                                            <Tooltip title={users.slice(6).map(function(u) { return u.name; }).join(', ')}>
                                                <OrgUserCard style={{ justifyContent: 'center' }}>
                                                    <span style={{ fontSize: 11, color: '#8c8c8c' }}>+{users.length - 6} mais</span>
                                                </OrgUserCard>
                                            </Tooltip>
                                        )}
                                        {users.length === 0 && (
                                            <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 8 }}>Sem usuários</div>
                                        )}
                                    </OrgUsersGrid>
                                </OrgBranch>
                            );
                        })}
                        {filteredCustomUsers.length > 0 && (
                            <OrgBranch>
                                <OrgGroupCard isCustom>
                                    <Icon type="setting" />
                                    <OrgGroupTitle>Personalizado</OrgGroupTitle>
                                    <OrgGroupCount>{filteredCustomUsers.length} usuários</OrgGroupCount>
                                </OrgGroupCard>
                                <OrgUsersGrid>
                                    {filteredCustomUsers.slice(0, 6).map(function(u) {
                                        return (
                                            <Tooltip
                                                key={u.id}
                                                title={
                                                    <div>
                                                        <div style={{ fontWeight: 500 }}>{u.name}</div>
                                                        <div style={{ fontSize: 11, opacity: 0.8 }}>{u.email}</div>
                                                    </div>
                                                }
                                                placement="bottom"
                                            >
                                                <OrgUserCard>
                                                    <Avatar size={24} style={{ backgroundColor: getAvatarColor(u.name), flexShrink: 0, fontSize: 10 }}>
                                                        {getInitials(u.name)}
                                                    </Avatar>
                                                    <OrgUserInfo>
                                                        <OrgUserName>{u.name}</OrgUserName>
                                                    </OrgUserInfo>
                                                </OrgUserCard>
                                            </Tooltip>
                                        );
                                    })}
                                    {filteredCustomUsers.length > 6 && (
                                        <Tooltip title={filteredCustomUsers.slice(6).map(function(u) { return u.name; }).join(', ')}>
                                            <OrgUserCard style={{ justifyContent: 'center' }}>
                                                <span style={{ fontSize: 11, color: '#8c8c8c' }}>+{filteredCustomUsers.length - 6} mais</span>
                                            </OrgUserCard>
                                        </Tooltip>
                                    )}
                                </OrgUsersGrid>
                            </OrgBranch>
                        )}
                    </OrgBranchContainer>
                </OrgTree>
                </OrgTreeWrapper>
            </OrgChartContainer>
        );
    };

    return (
        <div>
            <UsersHeader>
                <Input.Search
                    placeholder={viewMode === 'matrix' ? 'Pesquisar permissões' : 'Pesquisar grupos'}
                    onChange={function(e) { setSearch(e.target.value); }}
                    style={{ width: 250 }}
                    allowClear
                />
                <ViewToggle>
                    <Tooltip title="Visualização em lista">
                        <button
                            className={viewMode === 'list' ? 'active' : ''}
                            onClick={function() { setViewMode('list'); }}
                        >
                            <Icon type="unordered-list" />
                        </button>
                    </Tooltip>
                    <Tooltip title="Visualização em tabela">
                        <button
                            className={viewMode === 'table' ? 'active' : ''}
                            onClick={function() { setViewMode('table'); }}
                        >
                            <Icon type="table" />
                        </button>
                    </Tooltip>
                    <Tooltip title="Organograma">
                        <button
                            className={viewMode === 'org' ? 'active' : ''}
                            onClick={function() { setViewMode('org'); }}
                        >
                            <Icon type="apartment" />
                        </button>
                    </Tooltip>
                    <Tooltip title="Matriz de permissões">
                        <button
                            className={viewMode === 'matrix' ? 'active' : ''}
                            onClick={function() { setViewMode('matrix'); }}
                        >
                            <Icon type="build" />
                        </button>
                    </Tooltip>
                </ViewToggle>
                <div style={{ flex: 1 }} />
                <Button type="primary" onClick={function() { handleOpenModal(); }}>
                    <Icon type="plus" /> Novo Grupo
                </Button>
            </UsersHeader>

            {isLoading ? (
                viewMode === 'list' ? (
                    <div>
                        {[1, 2, 3].map(function(i) {
                            return (
                                <PermissionCard key={i}>
                                    <Skeleton active paragraph={{ rows: 0 }} />
                                </PermissionCard>
                            );
                        })}
                    </div>
                ) : viewMode === 'table' ? (
                    <div className="table-clabs">
                        <Skeleton active paragraph={{ rows: 5 }} />
                    </div>
                ) : (
                    // Skeleton.Button não existe no antd v3 — usar o Skeleton
                    // simples evita tela branca ao trocar de visão no loading
                    <div style={{ background: '#fff', border: '1px solid #f0f0f0', borderRadius: 8, padding: 24 }}>
                        <Skeleton active paragraph={{ rows: 6 }} />
                    </div>
                )
            ) : viewMode === 'matrix' ? (
                <PermissionsMatrixView groups={allSortedGroups} search={search} />
            ) : sortedList.length === 0 && filteredCustomUsers.length === 0 ? (
                <Empty
                    description={search ? "Nenhum grupo encontrado" : "Nenhum grupo de permissão cadastrado"}
                    style={{ padding: 40 }}
                />
            ) : viewMode === 'list' ? (
                renderListView()
            ) : viewMode === 'table' ? (
                renderTableView()
            ) : (
                renderOrgView()
            )}

            <PermissionsFormModal />
        </div>
    );
};

export default PermissionsContent;
